import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button/CaptionButton';
import { SuppliedRegistrationDialog } from '~/shared/components/ui/';

export const UISampleSuppliedRegistrationDialogs = () => {
  const [result, setResult] = useState('');
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  return (
    <div className="categories">
      <h3 id="dialog">支給品登録ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShowConfirm(true);
              }}
            />
            <SuppliedRegistrationDialog
              isOpen={isShowConfirm}
              onDecision={(v) => {
                setResult(
                  `出力しました。${v.suppliedParts}${v.suppliesDt}${v.suppliesRemarks}`
                );
                setIsShowConfirm(false);
              }}
              onCancel={() => {
                setResult('キャンセルしました');
                setIsShowConfirm(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{result}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
